import React, { FC } from "react";
import { Container } from "../../../../components";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import {
    hasLikeFinInsurance as hasLikeFinInsuranceSelector,
    hasMobileRefundItems as hasMobileRefundSelector,
    hasPreownedHandsetItems as hasPreownedHandsetItemsSelector,
    hasScreenOrPlusInsurance as hasScreenOrPlusInsuranceSelector,
} from "../../../state/selectors/cartSelectors";
import { hasSubscriptions as hasSubscriptionsSelector } from "../../../state/selectors/subscriptionsSelectors";
import TEXT from "../../../text-consts";

interface StateProps {
    hasLikeFinInsurance: boolean;
    hasMobileRefund: boolean;
    hasPreownedHandsetItems: boolean;
    hasScreenOrPlusInsurance: boolean;
    hasSubscriptions: boolean;
}

type DisclaimerCardProps = StateProps;

const DisclaimerCard: FC<DisclaimerCardProps> = ({
    hasSubscriptions,
    hasScreenOrPlusInsurance,
    hasLikeFinInsurance,
    hasMobileRefund,
    hasPreownedHandsetItems,
}) => (
    <Container size="small" noPaddingTop>
        <section className="summary-container__center spacer-top">
            {!hasSubscriptions && (
                <div
                    className="paragraph paragraph--fineprint"
                    dangerouslySetInnerHTML={{ __html: TEXT.SUMMARY.TELIA_FINANCE.TERMS_AND_CONDITIONS }}
                ></div>
            )}
            {hasSubscriptions && (
                <div
                    className="paragraph paragraph--fineprint"
                    dangerouslySetInnerHTML={{
                        __html: TEXT.SUMMARY.TELIA_FINANCE.TERMS_AND_CONDITIONS_WITH_SUBSCRIPTION,
                    }}
                ></div>
            )}
            {hasScreenOrPlusInsurance && !hasLikeFinInsurance && !hasPreownedHandsetItems && (
                <div
                    className="paragraph paragraph--fineprint"
                    dangerouslySetInnerHTML={{ __html: TEXT.SUMMARY.TERMS_AND_COND_FOR_SCREEN_AND_PLUSS_INSURANCE }}
                ></div>
            )}
            {hasScreenOrPlusInsurance && hasPreownedHandsetItems && (
                <div
                    className="paragraph paragraph--fineprint"
                    dangerouslySetInnerHTML={{ __html: TEXT.SUMMARY.TERMS_AND_CONDITIONS_LIKE_FIN_INSURANCE }}
                ></div>
            )}
            {hasLikeFinInsurance && (
                <div
                    className="paragraph paragraph--fineprint"
                    dangerouslySetInnerHTML={{ __html: TEXT.SUMMARY.TERMS_AND_CONDITIONS_LIKE_FIN_INSURANCE }}
                ></div>
            )}
            {hasMobileRefund && (
                <div
                    className="paragraph paragraph--fineprint"
                    dangerouslySetInnerHTML={{ __html: TEXT.SUMMARY.TERMS_AND_CONDITIONS_WITH_MOBILPANT }}
                ></div>
            )}
        </section>
    </Container>
);

const mapStateToProps: (state: RootState, ownProps: { subscriptionId?: string }) => StateProps = (state) => {
    return {
        hasScreenOrPlusInsurance: hasScreenOrPlusInsuranceSelector(state),
        hasLikeFinInsurance: hasLikeFinInsuranceSelector(state),
        hasMobileRefund: hasMobileRefundSelector(state),
        hasSubscriptions: hasSubscriptionsSelector(state),
        hasPreownedHandsetItems: hasPreownedHandsetItemsSelector(state),
    };
};

export default connect(mapStateToProps)(DisclaimerCard);
